import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { KeyValue } from "../models/common";
import { Result } from "../models/common/resultResponse";
import { IMunicipalityApi } from "./base/municipalityApi";
import { MunicipalityFilterRequest } from "../models/request";

const baseRoute: string = "Municipality";

export class MunicipalityApi extends IMunicipalityApi {
	getDomain(request: MunicipalityFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: request });
	}

	getDomainPublic(request: MunicipalityFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain_public`, { params: request });
	}
}
